import type { ErrorResponse } from '@/types/client.types';
import { putDeleteWorkerImmediate } from '@/apis/payment';
import { QUERY_KEY } from '@/constants/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import type { PutUnsubscribeWorkerRequestProps } from '@/types/payment.types';

const useDeleteWorkerImmediate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PutUnsubscribeWorkerRequestProps) =>
      putDeleteWorkerImmediate(body),
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY.PAYMENT_INFO]);
      toast.success('작업자가 삭제되었습니다.');
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      toast.error(error.response?.data.message);
    },
  });
};

export default useDeleteWorkerImmediate;

